export default function() {
	$('.searchpro').on('submit', function (event) {
		event.preventDefault();
		event.stopPropagation();
	});

	$('.searchpro__field-input').on('focus blur', function (e) {
		$(document).trigger('searchpro_field_focus_blur', [e.type]);
	})

	$(document).on('click', '.searchpro__dropdown-entity_delete-button', function (e) {
		e.preventDefault();
		const $parent = $(this).parent();
		$parent.hide(200, ()=>{
				$parent.remove();
		});
	})
}
